import { CartApiAdapter } from '../adapters/CartApiAdapter';
import {
  CreateCartRequest,
  Cart,
  CartFilters,
  CartPage,
  Product,
} from '../models/Cart';

export interface UpdateCartRequest {
  code: string;
  type_id: number;
}

export class CartService {
  constructor(private apiAdapter: CartApiAdapter) {}

  async getAllCarts(filters: CartFilters = {}): Promise<Cart[]> {
    return this.apiAdapter.getCarts(filters);
  }

  async getCartsPaginated(filters: CartFilters = {}): Promise<CartPage> {
    const { searchTerm, limit } = filters;

    if (limit && limit > 100) {
      throw new Error('El límite no puede ser mayor a 100');
    }

    if (searchTerm && searchTerm.length < 2) {
      throw new Error(
        'El término de búsqueda debe tener al menos 2 caracteres'
      );
    }

    return this.apiAdapter.getCartsPaginated(filters);
  }

  async getProducts(): Promise<Product[]> {
    return this.apiAdapter.getProducts();
  }

  async createCart(data: CreateCartRequest): Promise<Cart> {
    // 🎯 Validaciones de negocio - Solo código es obligatorio
    if (!data.code || data.code.trim().length < 2) {
      throw new Error('El código de carrito debe tener al menos 2 caracteres');
    }

    return this.apiAdapter.createCart(data);
  }

  async updateCart(id: number, data: UpdateCartRequest): Promise<Cart> {
    // 🎯 Validaciones de negocio - Solo código es obligatorio
    if (!data.code || data.code.trim().length < 2) {
      throw new Error('El código de carrito debe tener al menos 2 caracteres');
    }

    return this.apiAdapter.updateCart(id, data);
  }

  async deleteCart(id: number): Promise<void> {
    // 🎯 Validación básica
    if (!id || id <= 0) {
      throw new Error('ID de carrito inválido');
    }

    return this.apiAdapter.deleteCart(id);
  }
}

// 🎯 Alias para compatibilidad hacia atrás
export class LocationService extends CartService {}
export type UpdateLocationRequest = UpdateCartRequest;
